import { render, staticRenderFns } from "./informationMeasure.vue?vue&type=template&id=050d5156&"
import script from "./informationMeasure.vue?vue&type=script&lang=js&"
export * from "./informationMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports